import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardMedia,
  Grid,
  InputBase,
  Button,
} from "@material-ui/core";
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  NavLink,
  useHistory,
} from "react-router-dom";
import { Table, Empty, Dropdown, Menu } from "antd";
import TopSpacer from "../../../components/Common/spacer/TopSpacer";
import Breadcrumbs from "../../../components/BreadCrums/breadcrums";
import Logo from "../../../assets/img/logo.svg";
import Detail from "../../../assets/img/common/details.svg";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ClearIcon from "@material-ui/icons/Clear";
import { SearchOutlined as SearchIcon } from "@material-ui/icons";
import AddNewProgram from "./components/addNewProgram";
// import EditProgram from "./components/EditProgram";
import { PostDataAPI } from '../../../Services/APIService';
import ProgramDetails from "./programDetails/ProgramDetails";
import ChangeName from "./../../../assets/img/action/changeName.svg";
import DeleteNoSpace from "./../../../assets/img/icons/DeleteNoSpace.svg";
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import useStyles from "./styles";
import { withSnackbar } from "../../../components/Message/Alert";
import NoRecord from "../../../components/NoRecord/NoRecord";
import { Details } from "@material-ui/icons";
import Loader from "../../../components/Loader/Loader";

const CustomCard = ({ ...props }) => {
  const [data, setData] = useState([]);
  const classes = useStyles();
  const [addNewAddressDialog, setAddNewAddressDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState('');
  const { showMessage } = props;
  const [editItem, setEditItem] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [actiondialogState, setActionDialogState] = useState({
    showHide: false,
    type: "confirm",
    message: "",
  });

  const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
    setActionDialogState((prevState) => ({
      ...prevState,
      type: type,
      showHide: true,
      message: message,
      onClickOk: OnOkCallback,
      OnClickCancel: OnCancellCallback,
    }));
  };
  const deleteItem = (items) => {
    showActionDialog(
      "Are you sure you want to delete this record?",
      "confirm",
      function () {
        setIsLoading(true);

        PostDataAPI("fdngrantprograms/delete", items, true).then((result) => {
          if (result.success) {
            showMessage("Success", "Record deleted successfully", "success", 3000);
            loadPrograms();
          } else {
            showMessage("Error", result.message, "error", 3000);
          }
          setIsLoading(false);
        });
      }
    );
  };

  const closeAddAddress = () => {
    setAddNewAddressDialog(false);
    setEditData('');
  };

  const handleSuccessClose = (message) => {
    setEditItem({});
    closeAddAddress();
    showMessage("Success", message, "success", 3000);
    loadPrograms();
  }

  const addAddress = () => {
    setAddNewAddressDialog(true);
  };

  const EditProgram = (e) => {
    setAddNewAddressDialog(true);
    setEditData(e);
  };


  const loadPrograms = () => {
        setIsLoading(true);
    PostDataAPI("fdngrantprograms/loadGrid").then((result) => {
      console.log(result);
      if (result.success && result.data != null) {
           
        setData(
          result.data.map((item) => {
            // Assign the 'name' field the value of 'item.name'
            item.name = item.name;
            // You can also remove other assignments that concatenate multiple fields
            return { ...item };
          })
        );
         setIsLoading(false);
      } else {
        setData([]);
      }
    });
  };


  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [programDetail, setProgramDetail] = useState(false);

  const [programId, setProgramId] = useState(0);

  const programDetails = (programId) => {
    setProgramId(programId)
    setProgramDetail(true)
  }
  const closeProgramDetails = () => {
    setProgramDetail(false)
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleClearInput = (name) => {
    setSearchQuery('')
  };
  useEffect(() => {
    loadPrograms();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      const filtered = data.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchQuery, data]);

  return (
    <>
      <TopSpacer></TopSpacer>
      {isLoading ? <Loader></Loader> : ''}
      {programDetail ?
        <>
          <ProgramDetails closeProgramDetails={closeProgramDetails} programId={programId}></ProgramDetails>
        </> :
        <>
          <div className={classes.header}>
            <Grid container alignItems="baseline">
              <Grid item lg={12}>
                <Breadcrumbs parentLink={"Program List"} isBack={true}></Breadcrumbs>
              </Grid>
            </Grid>
          </div>

          <Grid container className={classes.gridHeader}>
            <Typography variant="h5" className={classes.GridHeading}>

            </Typography>
            <div className={"HeaderDialog"}>
              <div className={classes.gridActions}>
                <Button className={classes.changeBtn} onClick={() => addAddress()}>
                  <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Add New
                </Button>
              </div>
              <div className={classes.gridActions} style={{ marginRight: "7px" }}>
                <InputBase
                  placeholder="Search"
                  className="grid-search-input"
                  endAdornment={searchQuery ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                  startAdornment={<SearchIcon />}
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
          </Grid>


          {filteredData.length === 0 ? (
            <div className={classes.NoRecord}>
              <NoRecord Icon={true} message={"No program found"}></NoRecord>
            </div>
          ) : (
            <Grid container className={classes.Container}>
              {filteredData.map((item) => (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={3}
                  key={item.id}
                  className={classes.CardGrid}
                >
                  <div className={classes.Card}>
                    <div className={"CardBanner"}>
                      <img className={"BannerImg"} src={item.bannerImg} alt="Banner" onClick={() => programDetails(item.programId)} />

                      <Dropdown
                        overlay={
                          <Menu>
                            <Menu.Item className={classes.DropdownItems}>
                              <a
                                onClick={() => {
                                  EditProgram(item);
                                }}
                              >
                                <img
                                  className={classes.profileNavigationIco}
                                  src={ChangeName}
                                />
                                Edit
                              </a>
                            </Menu.Item>
                            <Menu.Item className={classes.DropdownItems}>
                              <a
                                onClick={() => {
                                  deleteItem(item);
                                }}
                              >
                                <img
                                  className={classes.profileNavigationIco}
                                  src={DeleteNoSpace}
                                />{" "}
                                Delete
                              </a>
                            </Menu.Item>
                          </Menu>
                        }
                        trigger={["click"]}
                        className={classes.actionDropDown}
                      >
                        <Button className={`DetailLogo ${classes.profileDropper}`}>
                          <img src={Detail} alt="Detail" />
                        </Button>
                      </Dropdown>
                    </div>
                    <div className={"CardMain"}>
                      <Typography variant="h4" className={"CardHeading"} onClick={() => programDetails(item.programId)}>
                        {item.name}
                      </Typography>
                      <div>
                        <Typography
                          variant="body2"
                          className={"CardBody"}
                          color="textSecondary"
                        >
                          <span
                            dangerouslySetInnerHTML={{ __html: item?.longDescription || "" }}
                          />
                        </Typography>
                      </div>
                      <img alt="logo" src={Logo} className={"CardLogo"} />
                    </div>
                  </div>
                </Grid>
              ))}

            </Grid>
          )};

        </>
      }





      <ActionDialog
        type={actiondialogState.type}
        message={actiondialogState.message}
        actiondialogOpenClose={actiondialogState.showHide}
        onSubmit={actiondialogState.onClickOk}
        onCancel={() =>
          setActionDialogState((prevState) => ({
            ...prevState,
            showHide: false,
          }))
        }
        onClose={() =>
          setActionDialogState((prevState) => ({
            ...prevState,
            showHide: false,
          }))
        }
      />

      {addNewAddressDialog ? (
        <AddNewProgram
          dialogOpenClose={addAddress}
          handleClose={closeAddAddress}
          handleSuccessClose={handleSuccessClose}
          editProgram={editData} // Conditionally pass EditProgram
        ></AddNewProgram>
      ) : (
        ""
      )}


    </>
  );
};

export default withSnackbar(CustomCard);
